import React from 'react';
import { useCart } from '../context/CartContext';
import { Truck, AlertTriangle } from 'lucide-react';

const FreeShippingPopup = () => {
  const { freeShippingPopup, setFreeShippingPopup, lostFreeShippingPopup, setLostFreeShippingPopup, freeShippingThreshold } = useCart();

  if (!freeShippingPopup && !lostFreeShippingPopup) return null;

  const isLost = lostFreeShippingPopup;
  const dismiss = () => { setFreeShippingPopup(false); setLostFreeShippingPopup(false); };

  const confettiPieces = [...Array(80)].map((_, i) => {
    const colors = ['#D97706', '#059669', '#DC2626', '#2563EB', '#7C3AED', '#F59E0B', '#10B981', '#EF4444', '#EC4899', '#FBBF24', '#06B6D4', '#8B5CF6'];
    const color = colors[i % colors.length];
    const angle = (i / 80) * 360 + (Math.random() * 15);
    const rad = (angle * Math.PI) / 180;
    const distance = 180 + Math.random() * 250;
    const endX = Math.cos(rad) * distance;
    const endY = Math.sin(rad) * distance + (Math.random() * 60);
    const size = 8 + Math.random() * 12;
    const delay = Math.random() * 0.2;
    const duration = 0.8 + Math.random() * 0.6;
    const rotation = Math.random() * 1080;
    const shape = i % 5;

    return (
      <div
        key={i}
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          width: `${size}px`,
          height: shape === 0 ? `${size}px` : shape === 1 ? `${size}px` : `${size * 2.5}px`,
          backgroundColor: color,
          borderRadius: shape === 0 ? '50%' : shape === 3 ? '50% 0 50% 0' : '2px',
          animation: `confettiBurst ${duration}s cubic-bezier(0.2, 0.8, 0.3, 1) ${delay}s forwards`,
          '--endX': `${endX}px`,
          '--endY': `${endY}px`,
          '--rot': `${rotation}deg`,
          opacity: 0,
          zIndex: 0,
        }}
      />
    );
  });

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-[60]" onClick={dismiss} />

      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[62] animate-popup" dir="rtl" style={{ overflow: 'visible' }}>
        {/* Confetti burst from popup */}
        {!isLost && (
          <div className="absolute pointer-events-none" style={{ overflow: 'visible', left: '50%', top: '50%', width: 0, height: 0 }}>
            {confettiPieces}
          </div>
        )}

        <div className="bg-white rounded-3xl shadow-2xl p-8 text-center max-w-xs w-full relative z-10" data-testid={isLost ? "lost-shipping-popup" : "free-shipping-popup"}>
          <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 ${isLost ? 'bg-amber-100' : 'bg-green-100'}`}>
            {isLost ? <AlertTriangle className="w-8 h-8 text-amber-500" /> : <Truck className="w-8 h-8 text-green-600" />}
          </div>
          <h2 className="text-2xl font-black text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
            {isLost ? 'אופס!' : 'איזה כיף!'}
          </h2>
          {isLost ? (
            <>
              <p className="text-stone-600 text-sm mb-1">הורדת מוצר ואתה מתחת ל-<strong className="text-[#D97706]">₪{freeShippingThreshold}</strong></p>
              <p className="text-amber-600 font-black text-lg">תוסיף מוצר ותקבל משלוח חינם!</p>
            </>
          ) : (
            <>
              <p className="text-stone-600 text-sm mb-1">הוספת לעגלה מעל <strong className="text-[#D97706]">₪{freeShippingThreshold}</strong></p>
              <p className="text-green-600 font-black text-lg">קיבלת משלוח ללא עלות!</p>
            </>
          )}
        </div>
      </div>

      <style>{`
        @keyframes popupIn {
          0% { transform: translate(-50%, -50%) scale(0.5); opacity: 0; }
          50% { transform: translate(-50%, -50%) scale(1.08); }
          100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
        }
        .animate-popup { animation: popupIn 0.35s ease-out; }
        @keyframes confettiBurst {
          0% { 
            transform: translate(-50%, -50%) rotate(0deg) scale(0); 
            opacity: 1; 
          }
          15% { 
            opacity: 1; 
            transform: translate(-50%, -50%) rotate(90deg) scale(1.2); 
          }
          80% { 
            opacity: 0.9; 
          }
          100% { 
            transform: translate(calc(-50% + var(--endX)), calc(-50% + var(--endY))) rotate(var(--rot)); 
            opacity: 0; 
          }
        }
      `}</style>
    </>
  );
};

export default FreeShippingPopup;
